import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AgendaFilterComponent } from '../components/agenda-filter/agenda-filter.component';
import { TableComponent } from '../components/analytics/common/table/table.component';
import { BulgariButtonComponent } from '../components/bulgari-button/bulgari-button.component';
import { BulgariFilterComponent } from '../components/bulgari-filter/bulgari-filter.component';
import { BulgariSnackbarComponent } from '../components/bulgari-snackbar/bulgari-snackbar.component';
import { ColumnVisibilityComponent } from '../components/column-visibility/column-visibility.component';
import { CreateShowcaseFormComponent } from '../components/create-showcase-form/create-showcase-form.component';
import { DashboardFilterComponent } from '../components/dashboard-filter/dashboard-filter.component';
import { CheckinDialogComponent } from '../components/dialogs/checkin-dialog/checkin-dialog.component';
import { ChooseEventDialogComponent } from '../components/dialogs/choose-event-dialog/choose-event-dialog.component';
import { DeleteDialogComponent } from '../components/dialogs/delete-dialog/delete-dialog.component';
import { ShowcasePictureDialogComponent } from '../components/dialogs/showcase-picture-dialog/showcase-picture-dialog.component';
import { TimezoneDialogComponent } from '../components/dialogs/timezone-dialog/timezone-dialog.component';
import { UploadDialogComponent } from '../components/dialogs/upload-dialog/upload-dialog.component';
import { DrawerComponent } from '../components/drawer/drawer.component';
import { HorizontalMenuOptionComponent } from '../components/horizontal-menu/horizontal-menu-option/horizontal-menu-option.component';
import { HorizontalMenuComponent } from '../components/horizontal-menu/horizontal-menu.component';
import { ImageWrapperComponent } from '../components/image-wrapper/image-wrapper.component';
import { LoaderComponent } from '../components/loader/loader.component';
import { PageHeaderComponent } from '../components/page-header/page-header.component';
import { PermissionComponent } from '../components/permission/permission.component';
import { AllocationContainerComponent } from '../components/product-allocation/allocation-container/allocation-container.component';
import { ProductAllocationComponent } from '../components/product-allocation/product-allocation.component';
import { TrayDetailComponent } from '../components/product-allocation/tray-detail/tray-detail.component';
import { TrayFormComponent } from '../components/product-allocation/tray-form/tray-form.component';
import { ProductAvatarComponent } from '../components/product-avatar/product-avatar.component';
import { ProgressUploadComponent } from '../components/progress-upload/progress-upload.component';
import { ProgressComponent } from '../components/progress/progress.component';
import { SearchSelectComponent } from '../components/search-select/search-select.component';
import { SelectBulgariComponent } from '../components/select-bulgari/select-bulgari.component';
import { MapComponent } from '../components/showcase-detail/map/map.component';
import { ProductComponent } from '../components/showcase-detail/product/product.component';
import { TableBulgariComponent } from '../components/table-bulgari/table-bulgari.component';
import { DndDirective } from '../directives/dnd.directive';
import { MaterialModule } from './material.module';
import { ConfirmDialogComponent } from '../components/dialogs/confirm-dialog/confirm-dialog.component';

const components = [
  LoaderComponent,
  BulgariFilterComponent,
  DashboardFilterComponent,
  AgendaFilterComponent,
  SearchSelectComponent,
  HorizontalMenuComponent,
  HorizontalMenuOptionComponent,
  ImageWrapperComponent,
  BulgariButtonComponent,
  SelectBulgariComponent,
  PageHeaderComponent,
  TableBulgariComponent,
  UploadDialogComponent,
  DeleteDialogComponent,
  ChooseEventDialogComponent,
  BulgariSnackbarComponent,
  ProgressUploadComponent,
  ProductAvatarComponent,
  ColumnVisibilityComponent,
  DndDirective,
  TimezoneDialogComponent,
  CheckinDialogComponent,
  PermissionComponent,
  MapComponent,
  CreateShowcaseFormComponent,
  DrawerComponent,
  ShowcasePictureDialogComponent,
  ProductComponent,
  ProductAllocationComponent,
  AllocationContainerComponent,
  TrayFormComponent,
  TrayDetailComponent,
  ProgressComponent,
  TableComponent,
  ConfirmDialogComponent,
];

@NgModule({
  declarations: [components],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [components, MaterialModule, ReactiveFormsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
